import { useField } from 'formik';

import Emoticon from '../layout/Emoticon';
import EmoticonContainer from '../layout/EmoticonContainer';

export default function StarsInput(props: { name: string }) {
	const choices = [1, 2, 3, 4, 5];
	const [, { value }, { setValue }] = useField(props.name);

	return (
		<EmoticonContainer>
			{choices.map((_, index) => (
				<Emoticon
					key={index}
					selected={value !== null && value >= index}
					onClick={() => setValue(index)}
				>
					⭐
				</Emoticon>
			))}
		</EmoticonContainer>
	);
}
